import React from 'react'
import { CustomQuoteProvider } from './src/views/custom-quote/context/CustomQuoteManager'
import { UserProvider } from './src/context/UserManager'
import {
  removeUVGuideLegacyCanonical,
  restoreLegacyCanonicalAfterUVGuide,
} from './lib/uv-printing-guide-canonical'

export const onPreRouteUpdate = (args) => {
  restoreLegacyCanonicalAfterUVGuide(args, document)
}

export const onRouteUpdate = ({ location }) => {
  removeUVGuideLegacyCanonical(location, document)
}

export const wrapPageElement = ({ element, props }) => {
  const isCustomQuotePage = props.path.startsWith(`/custom-quote/`)
  const needsUser =
    props.path.startsWith(`/instant-quote/`) || props.path.startsWith(`/app/`)

  if (isCustomQuotePage) {
    return <CustomQuoteProvider>{element}</CustomQuoteProvider>
  }

  if (needsUser) {
    return <UserProvider>{element}</UserProvider>
  }

  return <>{element}</>
}
